export function setDeclarationsPreview(state, payload) {
  state.declarationsPreview = payload;
}

export function setDeclarations(state, payload) {
  state.declarations = payload;
}

export function setAttachmentReadability(state, payload) {
  state.attachmentReadability = payload;
}
export function clearAttachmentReadability(state) {
  state.attachmentReadability = undefined;
}

export function clearDeclarations(state) {
  state.declarations = undefined;
}

export function clearDeclarationForm(state) {
  state.declarationForm = undefined;
}

export function setIsLoadingDeclarationsPreview(state, payload) {
  state.isLoadingDeclarationsPreview = payload;
}

export function setIsLoadingDeclarations(state, payload) {
  state.isLoadingDeclarations = payload;
}

export function setIsSavingDeclarations(state, payload) {
  state.isSavingDeclarations = payload;
}

export function setDeclarationForm(state, payload) {
  state.declarationForm = new FormData();
  state.declarationForm.set('customerSelected', payload.customerSelected);
  state.declarationForm.set('typeOfDeclaration', payload.typeOfDeclaration);
  state.declarationForm.set('couldThirdPartyBeLiable', payload.couldThirdPartyBeLiable);
  state.declarationForm.set('dateOfAccident', payload.couldThirdPartyBeLiable ? payload.dateOfAccident : '');
  state.declarationForm.set('accidentLocation', payload.accidentLocation);
  state.declarationForm.set('accidentDescription', payload.accidentDescription);
  state.declarationForm.set('counterPartyName', payload.counterPartyName);
  state.declarationForm.set('counterPartyPostalCode', payload.counterPartyPostalCode);
  state.declarationForm.set('counterPartyAddress', payload.counterPartyAddress);
  state.declarationForm.set('isTrafficAccident', payload.isTrafficAccident);
  state.declarationForm.set('hasTravelInsurance', payload.hasTravelInsurance);
  state.declarationForm.set('travelInsuranceInsurer', payload.travelInsuranceInsurer);
  state.declarationForm.set('travelInsurancePolicyNumber', payload.travelInsurancePolicyNumber);
  state.declarationForm.set('reasonMedicalCosts', payload.reasonMedicalCosts);

  if (payload.files && payload.files.length > 0) {
    payload.files.forEach((file) => state.declarationForm.append('files', file));
  }
}

export function setCustomers(state, payload) {
  state.customers = payload;
}

export function setIsLoadingCustomers(state, payload) {
  state.isLoadingCustomers = payload;
}

export function clearCustomers(state) {
  state.customers = [];
}
